/**
 * Configuración mínima de marca ("branding") de la aplicación.
 * Punto único para el nombre visible del producto — evita literales "PartnerCore"
 * hardcodeados dispersos por la UI. No toca logos/imágenes (fuera de alcance).
 */
export const BRANDING_CONFIG = {
  appName: 'Petlife',
} as const;
